import React from 'react';
import './_app-bar.scss';
import { NavLink } from 'react-router-dom';
import Icon from '../Icon/Icon';
import { withRouter } from 'react-router';
import Badge from '../Badge/Badge';

const AppBar = ({ location, cartQty = 0, launchInfo }) => {
  const AppBarItems = [
    {
      key: 'home',
      link: '/',
      title: 'home',
      icon: 'icon-home-selected',
      inactiveIcon: 'icon-home-unselected',
      hasBadge: false,
      visible: true,
    },
    {
      key: 'category',
      link: '/fruits-nuts-vegetables',
      title: 'categories',
      icon: 'icon-app-bar-category',
      inactiveIcon: 'icon-app-bar-category-unselected',
      hasBadge: false,
      visible: true,
    },
    {
      key: 'ramadan-special',
      link: '/ramadan-subscription',
      title: 'Subscribe',
      icon: 'icon-app-bar-subscription',
      inactiveIcon: 'icon-app-bar-subscription',
      hasBadge: false,
      visible: !!launchInfo?.isSubscriptionActive,
    },
    {
      key: 'cart',
      link: '/cart',
      title: 'Cart',
      icon: 'icon-app-bar-cart',
      inactiveIcon: 'icon-app-bar-cart',
      hasBadge: true,
      visible: true,
    },
    {
      key: 'account',
      link: '/my/details',
      title: 'account',
      icon: 'icon-app-bar-account',
      inactiveIcon: 'icon-app-bar-account-unselected',
      hasBadge: false,
      visible: true,
    },
  ];
  const isActive = menu => location.pathname === menu.link;
  const visibleMenus = AppBarItems.filter(i => i.visible);
  const width = 100 / visibleMenus.length + '%';
  return (
    <div className="app-bar">
      {AppBarItems.map(menu =>
        menu.visible ? (
          <NavLink
            className="app-bar--item"
            style={{ width }}
            activeClassName={'active-link'}
            key={menu.key}
            to={menu.link}
            exact={true}
          >
            <Icon
              class={isActive(menu) ? menu.icon : menu.inactiveIcon}
              size={30}
            />
            {menu.hasBadge && cartQty > 0 && (
              <div className="app-bar--item--cart-badge">
                <Badge text={cartQty} />
              </div>
            )}
            <div className="app-bar--item--title">{menu.title}</div>
          </NavLink>
        ) : (
          false
        )
      )}
    </div>
  );
};

export default withRouter(AppBar);
